@reference "../../styles/ui.css";

.jump-to-page {
  @apply gap-2 flex items-center self-stretch shrink-0;
}

.input {
  @apply border border-gray-300 self-stretch rounded-md px-2 py-1 text-center text-sm focus:outline-none focus:ring-1 focus:ring-blue-500 transition-colors;
}
